import React, { useState } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import axios from 'axios'; 
import logoImg from '../../assets/logo.png';
import './Navbar.css';

const Navbar = ({ onOpenForm, onOpenCareers }) => {
  const [searchActive, setSearchActive] = useState(false);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  // Helper function for smooth scrolling
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleSearch = async (e) => {
    const val = e.target.value;
    setQuery(val);
    
    if (val.length > 1) {
        try {
            const res = await axios.get(`http://127.0.0.1:5000/api/search?q=${val}`);
            setResults(res.data);
        } catch (err) {
            console.error(err);
        }
    } else {
        setResults([]);
    }
  };

  return (
    <header>
      <div className="top-bar">
        <div className="container">
          {/* UPDATED: Added onClick to About Us */}
          <span onClick={() => scrollToSection('integrated-coverage')}>About Us</span> | <span onClick={onOpenCareers}>Careers</span> | <span>Newsletter</span> | <span onClick={() => scrollToSection('speak-to-expert-section')}>Support</span> | <span>Login</span>
        </div>
      </div>

      <nav className="main-nav container">
        <div className="logo-area">
             <img src={logoImg} alt="Provenance Agri" className="nav-logo" />
        </div>
        
        {/* Hide Links if Search is Active */}
        {/* {!searchActive && (
            <ul className="nav-links">
            <li>Commodities</li>
            <li>Industries</li>
            <li>Solutions</li>
            <li>Events</li>
            <li>News & insights</li>
            </ul>
        )} */}

        {/* SEARCH BAR UI */}
        {searchActive && (
            <div className="search-container-active">
                <input 
                    type="text" 
                    placeholder="Type to search (e.g., Sugar, Careers)..." 
                    value={query}
                    onChange={handleSearch}
                    autoFocus
                />
                {/* Search Results Dropdown */}
                {results.length > 0 && (
                    <div className="search-results-dropdown">
                        {results.map((res, idx) => (
                            <div key={idx} className="search-result-item">
                                <strong>{res.title}</strong>
                                <span>{res.category}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )}

        <div className="nav-actions">
          {!searchActive && <button className="btn-specialist" onClick={onOpenForm}>Speak to a specialist &gt;</button>}
          
          <div className="search-trigger" onClick={() => {
              setSearchActive(!searchActive);
              setResults([]); // Clear results on toggle
              setQuery('');
          }}>
            {searchActive ? <FaTimes size={20} /> : <><span style={{marginRight:5}}>Search</span> <FaSearch /></>}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;